import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={37}
            height={36}
            viewBox="0 0 37 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M.92 9.485A9.485 9.485 0 0110.407 0h8.278c9.81 0 17.763 7.953 17.763 17.763 0 9.81-7.953 17.763-17.763 17.763-9.81 0-17.763-7.953-17.763-17.763V9.485z"
                fill={theme["#B4E3E1"]}
            />
            <path
                d="M18.378 8.83a4.313 4.313 0 100 8.626 4.313 4.313 0 000-8.626zm0 6.901a2.588 2.588 0 110-5.177 2.588 2.588 0 010 5.177zm7.764 9.489v-.863a6.038 6.038 0 00-6.039-6.038h-3.45a6.038 6.038 0 00-6.039 6.038v.863h1.725v-.863a4.313 4.313 0 014.314-4.313h3.45a4.313 4.313 0 014.313 4.313v.863h1.726z"
                fill={theme["#0D968F"]}
            />
        </svg>
    )
}
  
  export default SvgComponent